import AuthConfig from "@/config/auth";
import Auth from "@/plugins/auth";

export default function useAuth() {
  return Auth.getInstance(AuthConfig);
}
